"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.orcadDsnNumberingStyleFromFlag = orcadDsnNumberingStyleFromFlag;
exports.orcadDsnSectionDesignator = orcadDsnSectionDesignator;
exports.orcadDsnSignalIdSectionSuffix = orcadDsnSignalIdSectionSuffix;
exports.orcadDsnSectionPlacementName = orcadDsnSectionPlacementName;
const alphaDesignatorToConstant_1 = require("../../../../common/alphaDesignatorToConstant");
function orcadDsnNumberingStyleFromFlag(alphabeticNumbering) {
    return alphabeticNumbering === 1 ? 'alphabetic' : 'numeric';
}
function orcadDsnSectionDesignator(index, style) {
    if (style === 'alphabetic') {
        return (0, alphaDesignatorToConstant_1.indexToAlphaDesignator)(index + 1);
    }
    return `${index + 1}`;
}
function orcadDsnSignalIdSectionSuffix(index, style) {
    return `@s${orcadDsnSectionDesignator(index, style)}`;
}
function orcadDsnSectionPlacementName(bareReference, index, style) {
    const designator = orcadDsnSectionDesignator(index, style);
    return style === 'alphabetic' ? `${bareReference}${designator}` : `${bareReference}-${designator}`;
}
//# sourceMappingURL=OrcadDsnSectionNumbering.js.map